<template><div :id="randomId">

  <TsHeroBanner :dataTestid="componentName+'explore_event_card'"
                :backgroundImage="isMobile ? '/images/bg-event-mobile.webp' : '/images/bg-event.webp'" overlay overlay-class="bg-transparent" >
    <template #content>
      <TsRow append-class="items-center">
        <TsColumn>
          <slot name="title">
            <TsTypography appendClass="text-info mb-6" as="h2" variant="h1">
            {{ useTranslation('Events-joinDigitalRevolution', 'Sluit u aan bij de digitale revolutie') }}: <br><strong> {{ useTranslation('Events-discoverExclusiveEvents', 'Ontdek onze exclusieve evenementen') }}!</strong>
          </TsTypography></slot>
          <TsButton :dataTestid="componentName +'explore_button' "  :label="props.buttonLabel" />

        </TsColumn>
        <TsColumn>
          <TsImage alt="event_explore_image" v-if="props.image" :src="props.image" height="230" width="553" loading="lazy"/>
        </TsColumn>
      </TsRow>
    </template>
  </TsHeroBanner>
</div>
</template>
<script setup lang="ts">
import {onMounted, ref} from "vue";
import {useRandomUUID} from "~/composables/useRandomUUID";
const componentName='event_explore'
const randomId = ref<string>("");

onMounted(() => {
  randomId.value = useRandomUUID()})
type Props={
  buttonLabel?:string,
  image?:string
}
const props=withDefaults(defineProps<Props>(),{
  image:'/images/event-img.webp'
})
</script>